import request from "@/utils/cmsRequest";
const urlV2 = process.env.VUE_APP_BASE_API_V2;

export function verifyOTP(data) {
  return request({
    url: "/for_cms/login_with_otp",
    method: "post",
    data
  });
}

export function getInfo(token) {
  return request({
    url: "/admin/detail",
    method: "get",
    data: { token }
  });
}

export function logout() {
  return request({
    url: "admin/logout",
    method: "post"
  });
}

export function getOTP(data) {
  return request({
    url: "for_cms/get_sms_login",
    method: "post",
    data
  });
}

export function getCaptcha(param) {
  return request({
    url: "admin/get-captcha",
    method: "get",
    params: param
  });
}

export function verifyCaptcha(param) {
  return request({
    url: "/admin/verify-captcha",
    method: "get",
    params: param
  });
}

export function loginWap(data) {
  return request({
    url: "/for_wap/mapping_account_vgs",
    method: "post",
    data
  });
}

export function verifyOtpLogin(data) {
  return request({
    url: "for_wap/get_token_with_otp",
    method: "post",
    data
  });
}

export function getDetailUser(param) {
  return request({
    url: `${urlV2}/users/get_detail_user`,
    method: "get",
    params: param
  });
}

export function checkInfoUser(param) {
  return request({
    url: "/for_wap/check_info_user",
    method: "get",
    params: param
  });
}

export function updateInfoProfile(data) {
  return request({
    url: "/for_wap/update_info_user",
    method: "post",
    data
  });
}
